import script from "./ContributorOverviewUpper.vue?vue&type=script&setup=true&lang=js"
export * from "./ContributorOverviewUpper.vue?vue&type=script&setup=true&lang=js"

import "./ContributorOverviewUpper.vue?vue&type=style&index=0&id=0e87245d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e87245d"]])

export default __exports__